export const environment = {
  production: true,
  serverUrl: 'https://ep-ignytedev-exh3b5b2dnbfefhh.z02.azurefd.net/',
  apiVersion: '/api/v1',
};
